module.exports = __webpack_public_path__ + "static/media/box-up.32066a4f.svg";